import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";

const AdminLogin: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        throw error;
      }

      navigate("/admin");
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: error instanceof Error ? error.message : "Failed to sign in",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-lounge-dark text-lounge-light flex items-center justify-center">
      <div className="w-full max-w-md p-8 bg-lounge-charcoal rounded-lg border border-lounge-gold/20">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-display font-bold text-lounge-gold">Seven8Nine</h1>
          <p className="text-lounge-light/60 mt-2">Admin Portal</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-lounge-light/80 mb-1">
              Email
            </label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-lounge-dark border-lounge-gold/20 focus:border-lounge-gold"
              required
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-lounge-light/80 mb-1">
              Password
            </label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-lounge-dark border-lounge-gold/20 focus:border-lounge-gold"
              required
            />
          </div>

          <Button
            type="submit"
            className="w-full bg-lounge-gold hover:bg-lounge-gold/90 text-lounge-dark"
            disabled={isLoading}
          >
            {isLoading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin; 